<template>
    <div
        class="mx-auto h-[438px] w-[312px] bg-[url(/assets/art/cmspage_ad_bg.png)] bg-cover"
    >
        <div class="flex h-full flex-col px-6 pb-8 pt-3 text-center text-white">
            <div class="mb-8 font-medium">Need to recertify?</div>
            <div class="text-[16px] leading-7">
                The easiest way to get your CE hours, 100% online.
                <ul class="list-inside list-disc pb-0 pt-2 text-left">
                    <li>Dozens of courses and topics</li>
                    <li>State-specific requirements</li>
                    <li>We report to CAPCE in real time</li>
                </ul>
            </div>
            <div class="flex flex-grow items-center justify-center pb-2">
                <img src="/assets/art/capce_accredited_badge.png" />
            </div>
            <div class="">
                <a
                    href="https://emt-ce.com"
                    class="btn btn-primary block text-center"
                >
                    Go to EMT-CE.com
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "emtce-promo-ad",
};
</script>
